<script lang="ts">
  import { _ } from 'svelte-i18n';
  import Avatar from '../Avatar.svelte';

  export let isTemplate: boolean;

  export let owner;
  export let club;
  export let members_to_show;
  export let hidden_members;
  export let video_provider: string;
  export let video_name: string;
  export let video_id: string;
</script>

{#if !isTemplate}
  <div class="ellipsis" style="margin-bottom: 10px;">
    <Avatar img_style="margin-right: 8px;" shape="circle" {...owner}/>
    <h4 class="title w400 ellipsis" style="display: inline; vertical-align: middle;">
      {#if club != null}
        {club.display_name} - 
      {/if}
      {owner.first_name} {owner.last_name}
    </h4>
  </div>
{:else if video_provider == "bike_the_world"}
  <a class="logo" href="https://bikethe.world/xert/" style="margin-bottom: 10px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="500mm" height="500mm" viewBox="0 0 500 500">
      <path style="fill:#000;stroke-width:.37776163" d="M235.943 296.222c-17.003-1.188-32.282-3.56-47.1-7.314C128.88 273.715 76.434 236.625 42.44 185.37 20.944 152.959 8.12 118.646 2.616 78.805c-1.014-7.333-1.017-7.429-1.025-31.12-.01-26.01.05-26.952 2.683-42.249 16.69-96.99 88.912-175.037 184.465-199.345 11.702-2.977 24.73-5.229 38.692-6.688 9.22-.963 35.719-.962 45.207.003 22.53 2.29 42.06 6.627 61.853 13.736 77.855 27.963 136.61 92.505 157.196 172.68 9.195 35.808 10.265 72.849 3.16 109.393-11.17 57.459-42.592 109.45-88.478 146.398-14.327 11.536-27.92 20.208-45.143 28.798-27.46 13.697-56.173 21.88-88.21 25.139-5.573.567-31.776 1.042-37.073.672zm4.155-33.808a5240.561 5240.561 0 0 0-20.59-20.084c-13.05-12.662-22.42-22.334-28.87-29.8-22.325-25.848-37.134-51.995-41.708-73.641-1.54-7.288-1.4-16.148.395-24.873 2.715-13.199 10.49-24.204 22.53-31.89 9.67-6.175 24.297-9.488 38.93-8.82 15.721.719 27.966 2.71 54.476 8.856 21.115 4.895 31.014 6.761 44.591 8.405 9.243 1.119 26.113 1.215 31.613.18 10.7-2.015 16.909-5.68 19.91-11.753 5.8-11.739 5.307-34.46-15.42-61.855-17.804-23.532-41.547-54.398-73.495-82.744-3.69-3.273-13.554-12.968-13.554-12.968s-4.163 14.424-6.674 18.78c-18.104 42.424-59.497 91.676-94.456 131.645-12.273 14.032-29.108 32.116-29.729 31.935-.196-.057-.268.038-.16.212.222.359-19.039 19.689-19.622 19.693-.208.002-.379.158-.379.349 0 .452-7.6 7.603-7.834 7.37-.098-.097-.503.206-.9.674l-.723.851.946-.75c.52-.414-.587.689-2.46 2.45-5.567 5.236-7.991 7.41-7.187 6.448.416-.498-.918.734-2.965 2.737-2.047 2.003-3.882 3.543-4.076 3.423-.195-.12-.308-.074-.251.101.134.413-2.92 3.177-3.245 2.936-.135-.1-.174-.083-.088.038.173.242-2.993 3.058-10.75 9.566-2.808 2.357-5.153 4.398-5.21 4.537-.14.34 6.664 10.613 10.125 15.29 15.83 21.382 34.418 39.07 56.371 53.64 30.196 20.04 66.355 32.804 101.764 35.92 2.6.229 5.325.472 6.053.54.728.067 3.367.149 5.864.18l4.54.058zm115.116-17.679c13.17-6.59 31.475-19.166 43.778-30.077 49.14-43.577 76.673-106.472 75.16-171.688-.337-14.566-1.618-26.157-4.418-39.986-13.537-66.86-57.454-124.23-118.38-154.645-21.328-10.647-43.961-17.764-67.177-21.124-18.434-2.668-38.75-3.001-57.124-.937-27.14 3.05-55.003 11.705-78.94 24.52-19.494 10.438-35.186 21.91-50.773 37.12-18.447 18-32.5 37.214-43.743 59.804-5.285 10.62-8.415 18.172-12.118 29.234-16.193 48.38-15.294 100.76 2.551 148.624 1.354 3.631 2.669 6.998 2.922 7.482.456.874.503.85 6.864-3.423C94.324 102.422 134.323 66.363 166.14 28.38c31.235-37.287 55.492-77.035 72.357-118.569 3.859-9.503 6.16-15.864 7.844-21.69.78-2.697 1.55-5.046 1.71-5.22.389-.423 2.209 1.243 19.479 17.832 19.091 18.338 19.067 18.315 30.825 28.91 5.51 4.964 13.936 12.66 18.726 17.101 10.882 10.09 40.958 40.071 48.285 48.13 35.057 38.56 53.408 68.828 54.325 89.602.384 8.673-1.627 14.672-6.752 20.144-6.935 7.404-16.74 11.347-33.998 13.671-7.264.979-35.535.984-45.586.008-20.9-2.028-43.702-5.487-57.691-8.75-5.38-1.256-8.81-2.164-24.023-6.354-20.318-5.596-34.894-8.32-47.099-8.8-12.124-.479-17.558 1.93-21.123 9.36-2.272 4.735-2.71 6.364-2.705 10.05.01 7.18 2.423 11.95 10.711 21.171 13.123 14.6 38.05 35.734 63.054 53.457 13.217 9.369 16.531 11.483 34.047 21.722 21.161 12.37 62.958 35.7 64.04 35.746.161.007 1.353-.518 2.647-1.166zM106.99 124.92c.47-.598.457-.611-.143-.142-.63.493-.83.802-.52.802.08 0 .377-.297.663-.66z" transform="translate(0 203)"/>
    </svg>
    <h4 class="title w400" style="margin: 0;">
      Bike The World
    </h4>
  </a>
{/if}
{#if video_name != null}
  <div title={video_name} class="ellipsis">
    <a class="fa-brands fa-youtube" style="font-size: 14px; margin-bottom: 10px;"></a>
    <a href={`https://youtu.be/${video_id}`}>{video_name}</a>
  </div>
{/if}
{#if members_to_show != null && members_to_show.length > 0}
  <span class="avatars" style="margin-bottom: 10px;">
    {#each members_to_show as member}
      <Avatar shape="circle" is_spinning={member.is_workout_in_progress} {...member}/>
    {/each}
    {#if hidden_members.length > 0}
      <div title={hidden_members.slice(0, 15).reduce((a, v)=>a+v.first_name+" "+v.last_name+"\n", "")+(hidden_members.length>15 ? "..." : "")}>
        <p>+{hidden_members.length} {$_('sessions.card.additional_members')}</p>
      </div>
    {/if}
  </span>
{/if}

<style lang="scss">

svg {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

span.avatars {
  --avatar-height: 24px;

  display: flex;
  gap: 4px;
  width: 100%;
  max-width: var(--xert-button-width, unset);

  > div {
    margin: auto 0;
  }

  p {
    margin: 0;
    line-height: 1;
    color: var(--color-xert-gray-text);
  }
}

h4.title {
  text-align: left;
}

a.logo {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

</style>